module.exports = __webpack_public_path__ + "static/media/33.b1fefd65.jpg";